import styled from "styled-components";
import theme from "../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100vw;
  /* overflow-y: scroll; */
  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme.colors.brown.secundary};
    .logo {
      width: 500px;
      margin-top: 0vh;
      margin-bottom: -8vh;
      @media ${theme.devices.tablet} {
        width: 200px;
        margin-left: 7vw;
      }
    }
    .title {
      font-weight: bolder;
      font-size: ${theme.fontSize.lg};
      margin-top: -3vh;
      color: ${theme.colors.brown.primary};
    }
    .company {
      background-color: ${theme.colors.brown.primary};
      padding: 10px;
      padding-inline: 3vw;
      border-top-left-radius: 25px;
      border-top-right-radius: 25px;
      margin-top: 8vh;
      @media ${theme.devices.tablet} {
        padding-inline: 10vw;
        margin-top: 8.2vh;
      }
      .lbl {
        font-weight: bolder;
        font-size: ${theme.fontSize.md};
        color: white;
        @media ${theme.devices.tablet} {
          font-size: ${theme.fontSize.mm};
        }
      }
    }
  }
  .middle {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f7e7cc;
    padding-bottom: 2vh;
    .title {
      font-weight: bolder;
      font-size: ${theme.fontSize.lg};
      margin-top: 3vh;
      color: ${theme.colors.brown.primary};
      font-family: sans-serif;
    }
    .process-qtd {
      display: flex;
      flex-direction: row;
      margin-top: 2vh;
      align-items: center;
      column-gap: 1vw;
      margin-bottom: 3vh;
      font-family: ${theme.fonts.primary};
      .container {
        font-size: ${theme.fontSize.mm};
        color: white;
        padding: 5px;
        background-color: ${theme.colors.brown.primary};
        padding-inline: 2.5vw;
        border-radius: 5px;
      }
      .data {
        font-size: ${theme.fontSize.mm};
        color: ${theme.colors.brown.primary};
      }
      @media ${theme.devices.tablet} {
        column-gap: 4vw;
      }
    }
  }
  .bottom {
    display: flex;
    flex-direction: column;
    background: #faf4eb;
    height: 100%;
    width: 100%;
    .row {
      display: flex;
      flex-direction: row;
      height: 100%;
      width: 100%;
      overflow-wrap: anywhere;
      flex: 2;
      .form {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-inline: 4vw;
        .label {
          font-size: ${theme.fontSize.md};
          color: ${theme.colors.brown.primary};
          margin-top: 2vh;
          margin-bottom: 1vh;
        }
      }
      @media ${theme.devices.tablet} {
        flex-direction: column;
        width: 95%;
        margin-bottom: 5vh;
      }
    }
    .btns-contaienr {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      column-gap: 2vw;
    }
  }
`;

export const HomeInput = styled.input<{ width: string }>`
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  color: black;
  font-size: ${theme.fontSize.mm};
  width: ${(props) => props.width};
`;
export const TextAreaInput = styled.textarea`
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  color: black;
  font-size: ${theme.fontSize.mm};
  width: 100%;
  resize: none;
  font-family: sans-serif;
`;
export const HomeForm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 75vw;
  align-self: center;
  background-color: ${theme.colors.palete.brownExtraLighter};
  padding-inline: 3vw;
  height: 75%;
  .title {
    font-size: ${theme.fontSize.md2};
    color: black;
  }
  .btns-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    column-gap: 2vw;
    @media ${theme.devices.tablet} {
      flex-direction: column;
    }
  }
  @media ${theme.devices.tablet} {
    width: 85vw;
  }
`;

export const SubmitBtn = styled.button`
  font-size: ${theme.fontSize.mm};
  color: white;
  padding: 5px;
  background-color: ${theme.colors.brown.primary};
  padding-inline: 2.5vw;
  border-radius: 5px;
  margin-top: 3vh;
  margin-bottom: 5vh;
  width: 10vw;
  align-self: center;
  &:disabled {
    background-color: ${theme.colors.brown.capivara};
    cursor: not-allowed;
    opacity: 0.7;
  }
  @media ${theme.devices.tablet} {
    margin-bottom: 0vh;
    padding: 10px;
    width: 100%;
    font-size: ${theme.fontSize.md};
  }
`;
export const InputLbl = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .lbl {
    font-size: ${theme.fontSize.mm};
    margin-top: 1vh;
    align-self: center;

    color: ${theme.colors.brown.primary};
  }
`;
export const UserContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  .datagrid-container {
    display: flex;
    width: 75vw;
    height: 75vh;
    align-self: center;
    flex-direction: column;
    @media ${theme.devices.tablet} {
      width: 90vw;
      height: 80vh;
    }
  }
`;
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  column-gap: 2vw;
  @media ${theme.devices.tablet} {
    flex-direction: column;
    justify-self: center;
    display: flex;
    width: 93%;
  }
`;

export const AccountSelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 35vw;
  min-width: 35vw;
  width: 100%;
  .label {
    color: white;
    width: 100%;
    font-size: ${theme.fontSize.mm};
    text-align-last: right;
    margin-right: 1vw;
    @media ${theme.devices.tablet} {
      text-align-last: auto;
      margin-left: 5vw;
      width: 70vw;
    }
  }
  @media ${theme.devices.tablet} {
    max-width: 95vw;
    min-width: 95vw;
    column-gap: 0px;
    margin-bottom: 2vh;
  }
`;
export const DgContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 95%;
  align-self: center;
  .datagrid-container {
    display: flex;
    width: 75vw;
    height: 75vh;
    align-self: center;
    flex-direction: column;
    @media ${theme.devices.tablet} {
      width: 90vw;
      height: 80vh;
    }
  }
`;